/* global System */

import withLazyUnveil from 'scripts/higher-order-components/withLazyUnveil'

export default {
  RegionLocationMap: withLazyUnveil({
    loadComponent: () =>
      System.import(/* webpackChunkName: "RegionLocationMap" */ './index'),
    height: 445,
    mobileHeight: 622,
  }),
}
